import {
  CancelSubscriptionPromptModal,
  type CancelSubscriptionPromptModalProps,
} from "./CancelSubscriptionPromptModal";
import { EdgenModalCreateAble } from "@components/EdgenModal";

export interface CancelSubscriptionPromptModalCallableParams {
  onAction: CancelSubscriptionPromptModalProps["onAction"];
  actionLabel: CancelSubscriptionPromptModalProps["actionLabel"];
  onClose?: CancelSubscriptionPromptModalProps["onClose"];
}

export const openCancelSubscriptionPromptModal = (
  params: CancelSubscriptionPromptModalCallableParams,
): Promise<boolean> => {
  return new Promise<boolean>((resolve) => {
    // 这里使用 EdgenModalCreateAble 而非 react-call createCallable，
    // 避免页面未挂全局 Root 时出现 "No <Root> found"。
    const modalInstance = EdgenModalCreateAble.call({
      showClose: false,
      centered: true,
      destroyOnClose: true,
      containerClassName: "!md:w-[430px] !md:rounded-2xl",
      styles: {
        content: {
          backgroundColor: "transparent",
          padding: 0,
          borderRadius: "16px",
          overflow: "hidden",
        },
      },
      children: (
        <CancelSubscriptionPromptModal
          actionLabel={params.actionLabel}
          onClose={() => {
            params.onClose?.();
            EdgenModalCreateAble.end(modalInstance, false);
            resolve(false);
          }}
          onAction={() => {
            try {
              params.onAction();
            } finally {
              // 无论动作是否抛错，都要关闭当前提示弹窗，避免用户卡在弹窗内。
              params.onClose?.();
              EdgenModalCreateAble.end(modalInstance, true);
              resolve(true);
            }
          }}
        />
      ),
    });
  });
};
/**
 * 当前弹窗逻辑
 * 当前链路是：
 * 1. Member.tsx 在页面层获取 subscriptionListItems。
 * 2. 支付成功后，先弹原来的 UpgradeSuccessModalCreateAble 成功弹窗。
 * 3. 成功弹窗关闭后，执行 openCancelAutoRenewPromptIfNeeded。
 * 4. 判断是否应该弹取消续订提示：
 *    当前启用：买的是 LIFETIME 且购买前连续订阅项数量 > 0
 *    暂时注释保留：非 LIFETIME 且购买前连续订阅项数量 > 1
 * 5. 如果应该提示：
 *    有 canCancel 的订阅项：按钮显示 Manage Subscriptions，点击用第一条 canCancel 记录走 cancelSubscription
 *    没有 canCancel 的订阅项：按钮显示 Get it，点击只关闭弹窗
 */
